@if (href(); as link) {
  <a
    class="google-maps-link"
    [class.google-maps-link--pill]="variant() === 'pill'"
    [class.google-maps-link--compact]="variant() === 'compact'"
    [class.google-maps-link--inline]="variant() === 'inline'"
    [href]="link"
    target="_blank"
    rel="noopener noreferrer"
    [attr.aria-label]="variant() === 'compact' ? label() : null"
    (click)="$event.stopPropagation()"
  >
    <i class="bi bi-geo-alt" [class.bi-geo-alt-fill]="variant() !== 'inline'" aria-hidden="true"></i>
    @if (variant() !== 'compact') {
      <span class="google-maps-link-text">{{ label() }}</span>
    }
    <i class="bi bi-box-arrow-up-right google-maps-link-external" aria-hidden="true"></i>
  </a>
}
